export default __webpack_public_path__ + "media/images/portfolio/gallery-03-390x230-fcf14e1a0aeaa20d1fe9505ef31f9d4d.jpg";